import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import "../assets/auth.scss"
import userManager from '../utils/userManager';

class Authorization extends Component {

  componentDidMount(){
    const { user } = this.props
    if(!user){ userManager.signinRedirect();}
  }

  render() {
    const { user } = this.props
    if(user){ return <Redirect to='/'/> }
    return <div className="auth"><div className="loader"><img src="/images/loader.svg" alt="loader"/></div></div>
  }
}

export default connect(
  state => ({
    user: state.oidc.user,
  }) ,
  {}
)(Authorization);
